import { z } from 'zod';

/////////////////////////////////////////
// INSPECTIONS TYPES ITEMS SCHEMA
/////////////////////////////////////////

export const inspections_types_itemsSchema = z.object({
  id: z.bigint(),
  title: z.string(),
  type: z.string().nullable(),
  description: z.string().nullable(),
  order: z.number().int().nullable(),
  inspections_types_section_id: z.bigint().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  deleted_at: z.coerce.date().nullable(),
})

export type inspections_types_items = z.infer<typeof inspections_types_itemsSchema>

export default inspections_types_itemsSchema;
